import AreatroutTable from './Table';

export default AreatroutTable;
